<section>
  <div class="header astral-page-header">
    <h1>{{ 'DASHBOARD.MENU.REPORT_TAX_REDUCTION_LIST' | translate }}</h1>
    <div class="astral-page-header__actions">
      <astral-button variant="primary" size="small" type="button" icon="file" labelKey="REPORT.XML_FILE" (click)="exportToXML()"></astral-button>
      <astral-button variant="primary" size="small" type="button" icon="excel" labelKey="COMMON.EXCEL" (click)="exportToExcel()"></astral-button>
    </div>
  </div>

  <app-information-block [text]="'REPORT.HEADER_TOOLTIP.TAX_REDUCTION_REPORT' | translate"></app-information-block>

  <form class="filter astral-section-surface astral-form-stack astral-form-stack--relaxed report-filter-surface" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <astral-layout-group [columns]="6" [tabletColumns]="2" [mobileColumns]="1">
      <astral-select [control]="form.controls['company']" [itemsSource]="companies"></astral-select>
      <astral-select [control]="form.controls['articleId']" [itemsSource]="articles"></astral-select>
      <astral-date-picker [control]="form.controls['periodFrom']"></astral-date-picker>
      <astral-date-picker [control]="form.controls['periodTo']"></astral-date-picker>
    </astral-layout-group>
    <div class="astral-filter-actions">
      <astral-button variant="primary" size="small" type="submit" icon="search" labelKey="SEARCH_BTN"></astral-button>
    </div>
  </form>
</section>
